"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
const errors_1 = require("./errors");
class SessionServiceClient extends client_library_1.Client {
    constructor(fetch, options) {
        super(fetch, options);
    }
    async emitQuizSession(quizSessionReport) {
        const url = `${this.url}/api/session/quiz`;
        const expectedResponses = [200, 400];
        const response = await this.requestMaker.makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(quizSessionReport)
        }, expectedResponses);
        if (response.status === 400) {
            const body = response.json;
            throw new errors_1.BadRequestError(body.reason);
        }
        return;
    }
    async emitSession(session) {
        const url = `${this.url}/api/session`;
        const expectedResponses = [200, 400];
        const response = await this.requestMaker.makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(session)
        }, expectedResponses);
        if (response.status === 400) {
            const body = response.json;
            throw new errors_1.BadRequestError(body.reason);
        }
        return;
    }
}
exports.default = SessionServiceClient;
//# sourceMappingURL=SessionServiceClient.js.map